<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Single-Item-Select" type="checkbox" value=""
                        v-model="compState.autoStock">
                    <label class="form-check-label" for="Single-Item-Select">{{ t('Auto-stock') }}</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Show-on-Menu" type="checkbox" value=""
                        v-model="compState.returnsCanBeRestocked">
                    <label class="form-check-label" for="Show-on-Menu">{{ t('Returns can be restocked') }}</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Stock-Source" type="checkbox" value=""
                        v-model="compState.stockSource">
                    <label class="form-check-label" for="Stock-Source">{{ t('Stock Source') }}</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Stock Location') }}</h6>
                </label>
                <input v-model="compState.stockLocation" class="form-control" type="text" :placeholder="t('Name')"
                    maxlength="32">
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Stock Low Watermark') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')" v-model="compState.stockLowWatermark">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="stockLowWatermarkDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="stockLowWatermarkIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Stock High Watermark') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')"
                    v-model="compState.stockHighWatermark">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="stockHighWatermarkDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="stockHighWatermarkIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Sale to Stock Unit Ratio') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')"
                    v-model="compState.saleToStockUnitRatio">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="saleToStockUnitRatioDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="saleToStockUnitRatioIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <div class="mb-3">
                <h6 class="f-w-700 pb-1">{{ t('Current Stock Level') }} : {{ compState.currentStockLevel }}</h6>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Sale Unit') }}</h6>
                </label>
                <select v-model="compState.saleUnit" class="form-select" :aria-label="t('Sale Unit')">
                    <option value="" disabled>{{ t('Sale Unit') }}</option>
                    <option value="Individually">{{ t('Individually') }}</option>
                    <option value="Gram">{{ t('Gram') }}</option>
                    <option value="Kilogram">{{ t('Kilogram') }}</option>
                    <option value="Milligram">{{ t('Milligram') }}</option>
                    <option value="Ounce">{{ t('Ounce') }}</option>
                    <option value="Pound">{{ t('Pound') }}</option>
                    <option value="Carat">{{ t('Carat') }}</option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Stock Unit') }}</h6>
                </label>
                <select v-model="compState.stockUnit" class="form-select" :aria-label="t('Stock Unit')">
                    <option value="" disabled>{{ t('Stock Unit') }}</option>
                    <option value="Individually">{{ t('Individually') }}</option>
                    <option value="Gram">{{ t('Gram') }}</option>
                    <option value="Kilogram">{{ t('Kilogram') }}</option>
                    <option value="Milligram">{{ t('Milligram') }}</option>
                    <option value="Ounce">{{ t('Ounce') }}</option>
                    <option value="Pound">{{ t('Pound') }}</option>
                    <option value="Carat">{{ t('Carat') }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productsLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productsLanguage
})

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
})

const compState = reactive({
    autoStock: false,
    returnsCanBeRestocked: false,
    stockSource: false,
    stockLocation: '',
    stockLowWatermark: 0,
    stockHighWatermark: 0,
    saleToStockUnitRatio: 0,
    currentStockLevel: 0,
    saleUnit: '',
    stockUnit: ''
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        stock: {
            autoStock: newVal.autoStock,
            returnsCanBeRestocked: newVal.returnsCanBeRestocked,
            stockSource: newVal.stockSource,
            stockLocation: newVal.stockLocation,
            stockLowWatermark: newVal.stockLowWatermark,
            stockHighWatermark: newVal.stockHighWatermark,
            saleToStockUnitRatio: newVal.saleToStockUnitRatio,
            currentStockLevel: newVal.currentStockLevel,
            saleUnit: newVal.saleUnit,
            stockUnit: newVal.stockUnit
        }
    })

}, { deep: true });

const stockLowWatermarkIncrement = () => {
    compState.stockLowWatermark++
}

const stockLowWatermarkDecrement = () => {
    if (compState.stockLowWatermark > 0) {
        compState.stockLowWatermark--
    }
}
const stockHighWatermarkIncrement = () => {
    compState.stockHighWatermark++
}

const stockHighWatermarkDecrement = () => {
    if (compState.stockHighWatermark > 0) {
        compState.stockHighWatermark--
    }
}
const saleToStockUnitRatioIncrement = () => {
    compState.saleToStockUnitRatio++
}

const saleToStockUnitRatioDecrement = () => {
    if (compState.saleToStockUnitRatio > 0) {
        compState.saleToStockUnitRatio--
    }
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>